import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap, faCalendarAlt, faArrowRight, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FaReact, FaNodeJs, FaCss3Alt, FaEthereum, FaPalette, FaLaptopCode } from 'react-icons/fa';
import { SiMongodb, SiExpress, SiTailwindcss, SiSanity, SiWeb3Dotjs, SiHtml5, SiJavascript, SiSolidity } from 'react-icons/si';
import './Qualifications.css';
import dalogo from './da_logo.png';
import project1Image from './shareme.jpg';
import project2Image from './cryptowallet.jpg';
import project3Image from './steganography.png';
import project4Image from './sdr.webp';
import project5Image from './txt2dna.png';
import project6Image from './data_visualizer.png';
import project7Image from './task_mng.jpg'; 

const Qualifications = () => {
  const [expandedProject, setExpandedProject] = useState(null);

  const projects = [
    {
      id: 1,
      title: 'ShareMe: Social Media Web Application',
      image: project1Image,
      description: `Developed "ShareMe," an advanced Image Sharing Social Media web Application.
                    Integrated Google Authentication for secure access and streamlined user registration,
                    enhancing the user experience. Implemented features such as post creation, editing, likes,
                    comments, and image search, providing a comprehensive social media experience for users.`,
      tools: [
        { icon: <SiMongodb />, name: 'MongoDB' },
        { icon: <SiExpress />, name: 'Express.js' },
        { icon: <FaReact />, name: 'React.js' },
        { icon: <FaNodeJs />, name: 'Node.js' },
        { icon: <FaCss3Alt />, name: 'CSS3' },
        { icon: <SiTailwindcss />, name: 'Tailwind CSS' },
        { icon: <SiSanity />, name: 'Sanity.io' }
      ],
      link: 'https://drive.google.com/file/d/1dvBDHuvh9ZmZv7Ifj62mbx3ojuXWXPxG/view?usp=sharing'
    },
    {
      id: 2,
      title: 'Crypto Wallet Ethereum Transaction',
      image: project2Image,
      description: `This project is based on blockchain and smart contract technology.
                    We developed a decentralized web application on the Ethereum blockchain and smart contract.
                    Users can transfer Ethereum or withdraw Ethereum.`,
      tools: [
        { icon: <FaEthereum />, name: 'Ethereum' },
        { icon: <SiWeb3Dotjs />, name: 'Web3.js' },
        { icon: <FaReact />, name: 'React.js' },
        { icon: <SiHtml5 />, name: 'HTML5' },
        { icon: <SiJavascript />, name: 'JavaScript' },
        { icon: <FaNodeJs />, name: 'Node.js' },
        { icon: <SiSolidity />, name: 'Solidity' }
      ],
      link: 'https://github.com/Ashishkr05/crypto-wallet' // Replace with your actual project link
    },
    {
      id: 3,
      title: 'Steganography: Data Security Application',
      image: project3Image,
      description: `Python-based application using Flask microservices to demonstrate cryptography (symmetric key)
                    and steganography (modified LSB) for securing data over unsecured networks.`,
      tools: [
        { icon: <FaLaptopCode/>, name: 'Python' },
        { icon: <FaLaptopCode  />, name: 'Flask' },
        { icon: <FaLaptopCode />, name: 'Cryptography' },
        { icon: <FaPalette />, name: 'CSS' },
        { icon: <FaLaptopCode />, name: 'Bootstrap' }
      ],
      link: 'https://github.com/Ashishkr05/steganography-project' // Replace with your actual project link
    },
    {
      id: 4,
      title: 'Software Defined Radio',
      image: project4Image,
      description: `Using Software Defined Radio (SDR) tools like SDRSharp and RTL-SDR USB drivers to capture FM frequencies and sniff GSM signals.`,
      tools: [
        { icon: <FaLaptopCode />, name: 'SDRSharp' },
        { icon: <FaLaptopCode />, name: 'RTL-SDR USB Drivers' },
        { icon: <FaLaptopCode />, name: 'Zadig' },
        { icon: <FaLaptopCode />, name: 'GR-GSM' }
      ],
      link: 'https://github.com/Ashishkr05/Software-Defined-Radio' // Replace with your actual project link
    },
    {
      id: 5,
      title: 'Text2DNA: Digital Encoding Application',
      image: project5Image,
      description: `Converts text to binary for digital encoding, then transforms binary values into a nucleotide sequence for biological analysis.`,
      tools: [
        { icon: <FaLaptopCode />, name: 'Python' },
        { icon: <FaLaptopCode />, name: 'Flask' },
        { icon: <FaLaptopCode />, name: 'Symmetric Key Cryptography' },
        { icon: <FaLaptopCode />, name: 'LSB Steganography' }
      ],
      link: 'https://github.com/Ashishkr05/text2dna' // Replace with your actual project link
    },
    {
      id: 6,
      title: 'Data Visualizer: Analyzing Platform',
      image: project6Image,
      description: `Data analysis platform for grocery items, employing machine learning algorithms and generating various charts based on customer preferences.`,
      tools: [
        { icon: <FaLaptopCode />, name: 'Python' },
        { icon: <SiHtml5 />, name: 'HTML5' },
        { icon: <FaPalette />, name: 'CSS' },
        { icon: <FaLaptopCode />, name: 'Bootstrap' },
        { icon: <SiJavascript />, name: 'JavaScript' },
        { icon: <FaLaptopCode />, name: 'Apriori Algorithm' }
      ],
      link: 'https://github.com/Ashishkr05/Data-visualizer' // Replace with your actual project link
    },
    {
      id: 7,
      title: 'Task Manager Application',
      image: project7Image,
      description: `A simple task management application built using the MERN stack (MongoDB, Express.js, React.js, Node.js).`,
      tools: [
        { icon: <FaReact />, name: 'React.js' },
        { icon: <FaLaptopCode />, name: 'Angular' },
        { icon: <FaPalette />, name: 'CSS' },
        { icon: <SiHtml5 />, name: 'HTML5' },
        { icon: <FaNodeJs />, name: 'Node.js' },
        { icon: <SiExpress />, name: 'Express.js' },
        { icon: <SiMongodb />, name: 'MongoDB' }
      ],
      link: 'https://github.com/Ashishkr05/Task-Manager-Application/tree/master' // Replace with your actual project link
    },
  ];

  const toggleProject = (projectId) => {
    setExpandedProject(expandedProject === projectId ? null : projectId);
  };

  return (
    <div className="qualifications-container">
      <h2 className="projects-heading">College Projects</h2>
      <div className="education-card">
        <div className="education-header">
          <FontAwesomeIcon icon={faGraduationCap} className="icon" />
          <div className="education-details">
            <h3>Bachelor's in Technology</h3>
            <p>from Dhirubhai Ambani Institute of Information and Communication Technology</p>
          </div>
          <img src={dalogo} alt="DAIICT Logo" className="college-logo" />
        </div>
        <div className="education-subheader">
          <div className="branch">
            <p style={{ color: '#8C52FF' }}>In Information and Communication Technology</p>
          </div>
          <div className="timeline-date">
            <FontAwesomeIcon icon={faCalendarAlt} className="calendar-icon" />
            <p>Aug 2019 - May 2023</p>
          </div>
        </div>
        <div className="visit-college">
          <a href="https://www.daiict.ac.in/" className="website-link" target="_blank" rel="noopener noreferrer">
            Visit college website <FontAwesomeIcon icon={faArrowRight} className="arrow-icon" />
          </a>
        </div>
      </div>
      <div className="timeline-container">
        <div className="timeline">
          {projects.map((project, index) => (
            <div key={project.id} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
              <div className="timeline-content">
                <h3>{project.title}</h3>
                <span className="date-text">{project.date}</span>
                <a href={project.link} target="_blank" rel="noopener noreferrer">
                  <img src={project.image} alt={project.title} className="project-image" />
                </a>
                <button onClick={() => toggleProject(project.id)} className="view-more-button">
                  {expandedProject === project.id ? 'View Less' : 'View More'}{' '}
                  <FontAwesomeIcon icon={expandedProject === project.id ? faChevronUp : faChevronDown} />
                </button>
                {expandedProject === project.id && (
                  <div className="project-details">
                    <p>{project.description}</p>
                    <div className="tools-used">
                      {project.tools.map((tool, i) => (
                        <span key={i} className="tool">
                          {tool.icon} <span className="tool-name">{tool.name}</span>
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Qualifications;
